(function () {

    "use strict";

    angular.module("sphForms.auth", [
        // External
        "ui.router"
    ]);

}());